<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      size="full"
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>
      创建入库单<span v-if="purchaseOrders.length === 1" class="modal-secondary-title">{{purchaseOrders[0].code}}</span>
      <gj-tag
          type="plain"
          shape="rectangle"
          style="margin-left: 8px;"
          :color="purchaseOrders[0].status | optionColor(PurchaseOrderEnum.statusOption)">
        {{ purchaseOrders[0].status | optionText(PurchaseOrderEnum.statusOption) }}
      </gj-tag>
    </template>
    <template #content>
      <div v-if="false">
        <gj-input v-model="labelWidth" />
        <gj-input v-model="label1Width" />
        <gj-input v-model="inputWidth" />
      </div>
      <el-form
          ref="form"
          :model="form"
          :label-width="labelWidth">
        <gj-area-title>基本信息</gj-area-title>
        <el-row>
          <el-col :span="6">
            <el-form-item
                label="供应商"
                prop="name"
                :label-width="label1Width">
              <gj-text width="100%">{{purchaseOrders[0].supplierName | defaultShow}}</gj-text>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
                label="运费"
                prop="transportFee.value"
                :label-width="label1Width"
                :rules="[
                  $gjReRule(RE.num(2), '最多两位小数的正数'),
                  $gjMinRule(0.02, '应大于等于0.02'),
                ]">
                <gj-select-input
                  v-model="form.transportFee"
                  @input="transportFeeInput"
                  :options="[
                      {id: 'CNY', text: 'CNY'},
                      {id: 'USD', text: 'USD'}
                  ]"
                  :width="['85px', '100px']"
                ></gj-select-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
                label="其他费用"
                prop="otherFee.value"
                :label-width="label1Width"
                :rules="[
                  $gjReRule(RE.num(2), '最多两位小数的正数'),
                  $gjMinRule(0.02, '应大于等于0.02'),
                ]">
                <gj-select-input
                  v-model="form.otherFee"
                  @input="otherFeeInput"
                  :options="[
                      {id: 'CNY', text: 'CNY'},
                      {id: 'USD', text: 'USD'}
                  ]"
                  :width="['85px', '100px']"
                ></gj-select-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
                label="分摊方式"
                prop="shareMethod"
                :label-width="label1Width">
                <gj-select
                  :options="[
                    {id: 'amount', text: '按金额'},
                    {id: 'quantity', text: '按数量'}
                  ]"
                  v-model="form.shareMethod"
                  :clearable="false"
                ></gj-select>
            </el-form-item>
          </el-col>
        </el-row>
        <gj-area-title>产品明细</gj-area-title>
        <gj-table
            :index="false"
            :loading="loading"
            name="fastInboundOrder"
            :data="form.items"
            :columns="columns"
            :show-overflow="false"
            :structure-config="{type: 'ParentChild', children: 'products', parentSpan: [0, 7]}"
            :adapt-height="false">
          <template v-slot:picture="{row}">
            <template v-if="row.$gjParentData">
              <div v-gutter="20">
                <span>{{row.code | defaultShow}}</span>
                <span>{{row.deliveryWarehouseName | defaultShow}}</span>
                <span>采购量/交货量/入库量：{{row.totalOrderQuantity || 0}} / {{row.totalAlreadyDeliveryQuantity || 0}} / {{row.totalInboundQuantity || 0}}</span>
              </div>
            </template>
            <template v-else>
              <gj-image :src="row.smallImageUrl"></gj-image>
            </template>
          </template>
          <template v-slot:sku="{row}">
            <div>
              <gj-text>{{row.productName | defaultShow}}</gj-text>
            </div>
            <div>{{row.sku | defaultShow}}</div>
            <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
          </template>
          <template v-slot:header:inboundGoodQuantity>
            <span class="required-icon">*</span>入库良品量
            <gj-link @click="setInboundGoodQuantity">一键填入</gj-link>
          </template>
          <template v-slot:inboundGoodQuantity="{row}">
            <el-form-item
                :prop="`items.${row.$gjParentIndex}.products.${row.$gjChildIndex}.inboundGoodQuantity`"
                :rules="[
                  { required: true, message: '请输入入库良品量', trigger: ['change'] },
                  $gjReRule(RE.pt0, '请输入正整数')
                ]"
                label-width="0px"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[row.$gjParentIndex].products[row.$gjChildIndex].inboundGoodQuantity"
                  width="120px">
              </gj-input>
            </el-form-item>
          </template>
          <template v-slot:header:inboundBadQuantity>
            <span class="required-icon">*</span>入库次品量
            <gj-link @click="setInboundBadQuantity">一键填入</gj-link>
          </template>
          <template v-slot:inboundBadQuantity="{row}">
            <el-form-item
                :prop="`items.${row.$gjParentIndex}.products.${row.$gjChildIndex}.inboundBadQuantity`"
                :rules="[
                  { required: true, message: '请输入入库次品量', trigger: ['change'] },
                  $gjReRule(RE.pt0, '请输入正整数')
                ]"
                label-width="0px"
                class="gj-table-item">
              <gj-input
                  v-model="form.items[row.$gjParentIndex].products[row.$gjChildIndex].inboundBadQuantity"
                  width="120px">
              </gj-input>
            </el-form-item>
          </template>
        </gj-table>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formDeleteItemMixin, formRuleMixin, modalMixIn, responseMixin} from "../../../../../../minxins";
  import {fastInboundPurchaseOrder} from "../../../../../../api/purchase";
  import {ProductEnum} from "../../../../../../utils/options";
  import {PurchaseOrderEnum} from "../../enum";

  export default {
    name: "app-fast-inbound-modal",
    mixins: [modalMixIn, formRuleMixin, formDeleteItemMixin, responseMixin],
    props: {
      purchaseOrders: {
        required: true
      }
    },
    data() {
      return {
        loading: false,
        columns: [
          {id: 'picture', header: '图片', field: 'slot:picture', width: '60px'},
          {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '200px'},
          {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', width: '80px', align: 'right'},
          {id: 'orderQuantity', header: '采购量', field: 'orderQuantity', width: '80px', align: 'right'},
          {id: 'alreadyDeliveryQuantity', header: '已交量', field: 'alreadyDeliveryQuantity', width: '80px', align: 'right'},
          {id: 'noDeliveryQuantity', header: '未交量', field: 'noDeliveryQuantity', width: '80px', align: 'right'},
          {id: 'inboundGoodQuantity', header: 'slot:inboundGoodQuantity', field: 'slot:inboundGoodQuantity', width: '140px'},
          {id: 'inboundBadQuantity', header: 'slot:inboundBadQuantity', field: 'slot:inboundBadQuantity', width: '140px'},
        ],
        form: {
          items: [],
          transportFee: {
            key: "CNY",
            value: ""
          },
          otherFee: {
            key: "CNY",
            value: ""
          },
          shareMethod: "amount",
        },
        labelWidth: '90px',
        label1Width: '65px',
        inputWidth: '95%',
        productTypeOption: ProductEnum.typeOption,
        PurchaseOrderEnum: PurchaseOrderEnum
      }
    },
    created() {
      this.form.items = this.purchaseOrders.map(item => ({
        ...item,
        products: item.products.map(childItem => ({
          ...childItem,
          inboundGoodQuantity: null,
          inboundBadQuantity: null
        }))
      }));
    },
    methods: {
      // 其他费用改变
      otherFeeInput() {
        this.form.transportFee.key = this.form.otherFee.key
      },
      // 运费改变
      transportFeeInput() {
        this.form.otherFee.key = this.form.transportFee.key
      },
      // 入库良品量 一键填入
      setInboundGoodQuantity() {
        this.form.items.forEach(item => {
          item.products.forEach(product => {
            // 入库良品量 = 采购量 - 已交量
            // this.$set(product, 'inboundGoodQuantity', Number(product.orderQuantity) - Number(product.alreadyDeliveryQuantity));
            // 入库良品量 = 未交量 - 入库次品量
            this.$set(product, 'inboundGoodQuantity', Number(product.noDeliveryQuantity)-Number(product.inboundBadQuantity));
          });
        });
      },
      // 入库次品量 一键填入
      setInboundBadQuantity() {
        this.form.items.forEach(item => {
          item.products.forEach(product => {
            // 入库次品量 = 采购量 - 已交量
            // this.$set(product, 'inboundBadQuantity', Number(product.orderQuantity) - Number(product.alreadyDeliveryQuantity));
            // 入库次品量 = 未交量 - 入库良品量
            this.$set(product, 'inboundBadQuantity', Number(product.noDeliveryQuantity)-Number(product.inboundGoodQuantity));
          });
        });
      },
      confirm() {
        if (this.$gjFormValidate()) {
          const params = this.form.items.map(item => ({
            id: item.id,
            otherFee: this.form.otherFee.value,
            feeCurrency: this.form.otherFee.key,
            shareMethod: this.form.shareMethod,
            transportFee: this.form.transportFee.value,
            products: item.products.map(product => ({
              id: product.id,
              inboundGoodQuantity: product.inboundGoodQuantity,
              inboundBadQuantity: product.inboundBadQuantity,
            }))
          }));
          this.confirmLoading = true;
          fastInboundPurchaseOrder(params)
            .then(res => {
              this.$gjResponseHandle(res, () => {
                this.$gjMessage.success('操作成功');
                this.$emit('created');
                this.$gjDestroy();
              });
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    }
  }
</script>

<style scoped>

</style>
